export default "__VITE_ASSET__c19cc413__"